<div *ngIf="!isLogged">
  <form [formGroup]="loginForm" novalidate>
    <mat-card class="admin-card">
      <mat-card-header>
        <mat-card-title>Admin page</mat-card-title>
      </mat-card-header>
      <mat-card-content>

        <div class="row">
          <div class="col">
            <mat-form-field class="full-width">
              <input matInput placeholder="Email" formControlName="email">
              <mat-error
                *ngIf="loginForm.controls['email'].hasError('required') && loginForm.controls['email'].touched">
                Email name is <strong>required</strong>
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <mat-form-field class="full-width">
              <input matInput type="password" placeholder="Password" formControlName="password">
              <mat-error *ngIf="loginForm.controls['password'].hasError('required')">
                Password is <strong>required</strong>
              </mat-error>
            </mat-form-field>
          </div>
        </div>

      </mat-card-content>
      <mat-card-actions>
        <button (click)="signIn()" mat-raised-button color="primary" type="submit">Login</button>
      </mat-card-actions>
    </mat-card>
  </form>
</div>


<div *ngIf="isLogged" class="signed-in">
  <mat-card>
    <mat-card-header>
      <mat-card-title>Hello {{ (authService.userData| async)?.email }}</mat-card-title>
      <mat-card-actions>
        <button (click)="signOut()" mat-raised-button color="accent">Logout</button>
      </mat-card-actions>
    </mat-card-header>

    <mat-card-content>

      <h2>Sold books revenues</h2>
      <div class="example-container mat-elevation-z8">
        <table mat-table [dataSource]="books$|async">

          <ng-container matColumnDef="title">
            <th mat-header-cell *matHeaderCellDef> Title </th>
            <td mat-cell *matCellDef="let book"> {{book.title}} </td>
            <td mat-footer-cell *matFooterCellDef> Total </td>
          </ng-container>

          <ng-container matColumnDef="sold">
            <th mat-header-cell *matHeaderCellDef> Sold pcs. </th>
            <td mat-cell *matCellDef="let book"> {{book.sold}} </td>
            <td mat-footer-cell *matFooterCellDef> </td>
          </ng-container>

          <ng-container matColumnDef="price">
            <th mat-header-cell *matHeaderCellDef> Price </th>
            <td mat-cell *matCellDef="let book"> {{book.price }} </td>
            <td mat-footer-cell *matFooterCellDef> {{getTotalCost()|async|currency:'EUR'}} </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          <tr mat-footer-row *matFooterRowDef="displayedColumns; sticky: true"></tr>
        </table>
      </div>
    </mat-card-content>


  </mat-card>
</div>